export const studyListCookies = {
  studyInProgress: 'study_in_progress',
  deTemplatePublished: 'de_template_published',
  deMovedBack: 'de_moved_back',
  qaTemplatePublished: 'qa_template_published',
  qaMovedBack: 'qa_moved_back',
};
